<template>
    <div class="p-25">
            <div class="row">
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">Kod</label>
                    <input type="text" class="form-control" v-model="value.Code" placeholder="Kod" />
                </div>
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">Ad</label>
                    <input type="text" class="form-control" v-model="value.Name" placeholder="Ad" />
                </div>
                <div class="col-12 col-lg-6 mb-1">
                    <label class="form-label">Öncelik</label>
                    <input type="text" class="form-control" v-model="value.Priority" placeholder="Öncelik" />
                </div>
            </div>
        </div>
</template>

<script>
import {BFormCheckbox,BInputGroup,BFormInput,BInputGroupAppend,BTabs,BTab} from 'bootstrap-vue'
import HRParametersApi from '@/api/human-resources-parameters'

export default {
    components: {
        BFormCheckbox,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BTabs,
        BTab,
        HRParametersApi
    },
    props:{
        value:Object
    }
}
</script>